import React, { useState } from "react";

// Translations
import { useTranslation } from "react-i18next";

// MUI
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// MUI Icons
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CloseIcon from '@mui/icons-material/Close';

// Components
import FilePreviewBadge from "../../FilePreviewBadge";
import LinkPreview from "../LinkPreview";

// Types
import { APIId, Note } from "../../../types";

// Styles
import styles from './style.module.scss';

interface NoteGroupProps {
  note: Note;
  onRemove?: (noteId: APIId) => void;
}

const NoteGroup: React.FC<NoteGroupProps> = ({ note, onRemove = undefined }) => {
  // Hooks
  const { t } = useTranslation();

  // State
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (!note) return null;
  const { title, file_sources, link_sources } = note;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconButton onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>

          <div className={styles.data}>
            <Typography variant='subtitle1' color='textSecondary'>
              {t('masteryMap.map.smart_note')}
            </Typography>

            <Typography variant='body1' color='textPrimary'>
              {title}
            </Typography>
          </div>

        </div>

        {onRemove && (
          <IconButton
            onClick={() => onRemove(note.id)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>

      <div className={styles.content} style={{ display: isOpen ? 'flex' : 'none' }}>
        {link_sources.length === 0 && file_sources.length === 0 && (
          <Typography variant='subtitle1' color='textSecondary'>
            {t('attachMaterials.no_files_or_links')}
          </Typography>
        )}

        {link_sources.map(link => <LinkPreview link={link} />)}

        {file_sources.map(file => <FilePreviewBadge fileId={file} />)}
      </div>
    </div>
  )
}

export default NoteGroup;
